import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { COUNT_MONTH_MPLUS } from 'shared/constants'

import { PaymentIcon } from '../payment-icon'

import s from './styles.module.scss'

interface Props {
  onClick?: () => void
}

export const ConnectMplusCard: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <div
      className={s.container}
      onClick={onClick}
    >
      <PaymentIcon variant="mplus" />

      <div className={s.text}>
        <p className={clsx(s.title, 'semi-bold-14')}>
          {t('payment_method.connect_mplus')}
        </p>

        <p className={clsx(s.subTitle, 'medium-12')}>
          {t('payment_method.mplus_installment', { count: COUNT_MONTH_MPLUS })}
        </p>
      </div>
    </div>
  )
}
